
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ScrollToTop from './components/feature/ScrollToTop';
import SEOHead from './components/feature/SEOHead';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <SEOHead />
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
